import fetcher from 'utils/api';

export default {
  fetch: async ({ teamId, isPrivate = false }: { teamId: string; isPrivate: boolean }) => {
    return fetcher(`organizations/${teamId}/folders/tree/${isPrivate ? '?is_private=True' : ''}`, 'GET', true);
  },
  move: async (folderId: string, parentId: string | null) => {
    return fetcher(`folders/${folderId}/move`, 'POST', true, { parent_id: parentId });
  }
};
